import { Directive, TemplateRef, ViewContainerRef, Input} from '@angular/core';
import {StorageService} from '../services/storage.service';

@Directive({
  selector: '[appHasRoles]'
})
export class HasRolesDirective {

  constructor(
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private _storageService: StorageService
  ) {}

  @Input()
  appHasRoles: string;

  ngOnInit() {
    let hasRole= true;
    
    //Si el rol viene a null entiendo que no está protegido por tanto visible
    //Si viene comprobamos que sea el rol del usuario
    if (this.appHasRoles!=null ) {
      hasRole = this._storageService.hasRole(this.appHasRoles);      
    }
  
    if (hasRole) {
      this.viewContainer.createEmbeddedView(this.template);
    } else {
      this.viewContainer.clear();
    }    
  }


  renderElement(condition: boolean) { 
    if (condition) {
      this.viewContainer.createEmbeddedView(this.template)
    } else {
      this.viewContainer.clear();
    }
  }

}
